import { useLazyQuery } from '@apollo/client';
import { useEffect } from 'react';
import { CrewMemberEarnableHoursInput, PersonaType } from '@bechtel/types';
import { GET_EARNABLE_HOURS } from '@bechtel/client-gql';
import { get } from 'lodash';
import {
  AllGeneralForemanId,
  UnassignedGeneralForemanId,
  AllForemanId,
  UnassignedForemanId,
  AllSuperintendentId,
  UnassignedSuperintendentId,
  usePlanning,
} from '@bechtel/client-common';

export const useEarnableHours = (item) => {
  const { selectedSuperintendent, selectedGeneralForeman } = usePlanning();
  const [getEarnableHours, { loading, data }] =
    useLazyQuery<{ input: CrewMemberEarnableHoursInput }>(GET_EARNABLE_HOURS);
  const allEarnableHours = get(data, 'earnableHours.allEarnableHours');
  const unassignedEarnableHours = get(data, 'earnableHours.unassignedEarnableHours');
  const crewMemberEarnableHours = get(data, 'earnableHours.crewMemberEarnableHours[0].earnableHours');
  useEffect(() => {
    if (item.persona === PersonaType.SUPERINTENDENT) {
      if (item.id === AllSuperintendentId || item.id === UnassignedSuperintendentId) {
        getEarnableHours({
          variables: {
            input: {},
          },
        });
      } else {
        getEarnableHours({
          variables: {
            input: {
              crewMembers: [
                {
                  persona: item?.persona,
                  crewMemberId: item?.id,
                },
              ],
            },
          },
        });
      }
    } else if (item.persona === PersonaType.GENERAL_FOREMAN) {
      if (item.id === AllGeneralForemanId || item.id === UnassignedGeneralForemanId) {
        getEarnableHours({
          variables: {
            input: {
              crewMembers: [],
              supervisor: {
                persona: selectedSuperintendent?.persona,
                crewMemberId: selectedSuperintendent?.id,
              },
            },
          },
        });
      } else {
        getEarnableHours({
          variables: {
            input: {
              crewMembers: [
                {
                  persona: item?.persona,
                  crewMemberId: item?.id,
                },
              ],
              supervisor: {
                persona: selectedSuperintendent?.persona,
                crewMemberId: selectedSuperintendent?.id,
              },
            },
          },
        });
      }
    } else if (item.persona === PersonaType.FOREMAN) {
      if (item.id === AllForemanId || item.id === UnassignedForemanId) {
        getEarnableHours({
          variables: {
            input: {
              crewMembers: [],
              supervisor: {
                persona: selectedGeneralForeman?.persona,
                crewMemberId: selectedGeneralForeman?.id,
              },
            },
          },
        });
      } else {
        getEarnableHours({
          variables: {
            input: {
              crewMembers: [
                {
                  persona: item.persona,
                  crewMemberId: item?.id,
                },
              ],
              supervisor: {
                persona: selectedGeneralForeman?.persona,
                crewMemberId: selectedGeneralForeman?.id,
              },
            },
          },
        });
      }
    }
  }, [item, selectedGeneralForeman, selectedSuperintendent, getEarnableHours]);

  let earnableHours;

  if (item.id === AllSuperintendentId || item.id === AllGeneralForemanId || item.id === AllForemanId) {
    earnableHours = allEarnableHours;
  } else if (
    item.id === UnassignedSuperintendentId ||
    item.id === UnassignedGeneralForemanId ||
    item.id === UnassignedForemanId
  ) {
    earnableHours = unassignedEarnableHours;
  } else {
    earnableHours = crewMemberEarnableHours;
  }

  return { earnableHours, loading };
};
